'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactRouter = require('react-router');

var _goals = require('redux/modules/goals');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module1App10 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module1,
    app: state.moduleData.data.module1.app10,
    profile: state.profile.data,
    strategies: state.goals.data.strategies
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem, updateStrategies: _goals.updateStrategies })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1App10, _Component);

  function Module1App10() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1App10);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1App10.__proto__ || (0, _getPrototypeOf2.default)(Module1App10)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 12,
      title: 'Strategies',
      isCompleted: _this.props.app.isCompleted || false,
      showModal: false,
      strategies: _this.props.strategies || [{ strategy: '', steps: '', whatIsNeeded: '' }],
      hardcodedStrats: [{
        strategy: 'Consistently offer fruit and vegetables',
        steps: 'Plan - this ensures plenty of fruit and vegetables available\n' + 'Record your child\'s intake, this let\'s you see what she is ' + 'actually having and additional times you might be able to ' + 'offer vegetables.',
        whatIsNeeded: 'Buy extra fruit and vegetables to be able to provide my child with ' + 'fruit and vegetables at every meal.',
        add: false
      }, {
        strategy: 'Understanding serve sizes',
        steps: 'Read over \'What is a serve\' - you can find a reminder of serve ' + 'sizes for fruit and vegetables under Resources - Module 1 and ' + 'for the other food groups.',
        whatIsNeeded: 'Set aside time during the week to read and understand ' + 'serving sizes.',
        add: false
      }, {
        strategy: 'Limit non-core (or sometimes) foods',
        steps: 'Store non-core foods in a place my child doesn\'t know.\n' + 'Store non-core foods in containers that my child can\'t see through.\n' + 'Create a family rule that children must ask before they take ' + 'a \'sometimes\' food.',
        whatIsNeeded: 'Make space in cupboards up high or pop into large saucepans. ' + 'Buy or acquire non-see-through containers.\n' + 'Chat to your partner or other adults in the family about what you have ' + 'learnt in Module 1 and encourage them to do the same so they understand ' + 'what you are trying to achieve this week and the importance of it.',
        add: false
      }, {
        strategy: 'Prepare healthy meals and snacks',
        steps: 'Use the recipes under Resources. Remember to plan to buy the required ingredients.',
        whatIsNeeded: 'Buy the ingredients needed and set aside time to prepare a healthy/meal snack',
        add: false
      }]
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      _this.setState({ 'showModal': true, isCompleted: true });

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, {'isCompleted': true});
      _this.props.updateModuleApp(_this.props.user.userId, 1, 10, { 'isCompleted': true });

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      var index = void 0;
      for (index = 0; index < _this.state.hardcodedStrats.length; index++) {
        if (_this.state.hardcodedStrats[index].add) {
          // if the hardcoded strat is added, but was already in our strategies, then we decide
          // to not add it
          var temp = void 0;
          var shouldAdd = true;
          for (temp = 0; temp < _this.state.strategies.length; temp++) {
            if (_this.state.strategies[temp].strategy === _this.state.hardcodedStrats[index].strategy && _this.state.strategies[temp].steps === _this.state.hardcodedStrats[index].steps) {
              shouldAdd = false;
              break;
            }
          }
          if (shouldAdd) {
            _this.state.strategies.push({ strategy: _this.state.hardcodedStrats[index].strategy,
              steps: _this.state.hardcodedStrats[index].steps,
              whatIsNeeded: _this.state.hardcodedStrats[index].whatIsNeeded });
          }
        } else {
          // if the hardcoded strategy was already pushed on, but add was false, then we splice it off
          var _temp3 = void 0;
          for (_temp3 = _this.state.strategies.length; _temp3--;) {
            if (_this.state.strategies[_temp3].strategy === _this.state.hardcodedStrats[index].strategy && _this.state.strategies[_temp3].steps === _this.state.hardcodedStrats[index].steps) {
              _this.state.strategies.splice(_temp3, 1);
              break;
            }
          }
        }
      }

      // clean strategies state, iterate backwards
      for (index = _this.state.strategies.length; index--;) {
        if (_this.state.strategies[index].strategy === '') {
          _this.state.strategies.splice(index, 1);
        }
      }

      _this.props.updateStrategies(_this.props.user.userId, _this.state.strategies);
    }, _this.handleAddStrategy = function () {
      var obj = _this.state;
      obj.strategies.push({ strategy: '', steps: '', whatIsNeeded: '' });
      _this.setState(obj);
    }, _this.handleRemoveStrategy = function (index) {
      var obj = _this.state;
      obj.strategies.splice(index, 1);
      _this.setState(obj);
    }, _this.handleChange = function (index) {
      var obj = _this.state;
      obj.hardcodedStrats[index].add = !obj.hardcodedStrats[index].add;
      _this.setState(obj);
    }, _this.handleOwnStrategy = function (number, value) {
      var obj = _this.state;
      obj.strategies[number].strategy = value;
      _this.setState(obj);
    }, _this.close = function () {
      var obj = _this.state;
      obj.showModal = false;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module1App10, [{
    key: 'componentWillMount',


    /*
     * Handle when user finishes this module
     */
    // handleComplete = () => {
    //   const obj = this.state;
    //   obj.showModal = true;
    //   obj.isCompleted = true;
    //   this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
    //   this.setState(obj);
    // }

    value: function componentWillMount() {
      var obj = this.state;
      var index = 0;

      for (index = 0; index < this.state.hardcodedStrats.length; index++) {
        var temp = 0;
        for (temp = 0; temp < this.state.strategies.length; temp++) {
          if (this.state.strategies[temp].strategy === this.state.hardcodedStrats[index].strategy && this.state.strategies[temp].steps === this.state.hardcodedStrats[index].steps && this.state.strategies[temp].whatIsNeeded === this.state.hardcodedStrats[index].whatIsNeeded) {
            obj.hardcodedStrats[index].add = true;
          }
        }
      }
      this.state = obj;
    }

    /*
     * Handle when user finishes this module
     */


    /*
     * Adds another strategy to the front end UI
     */


    /*
     * Changing checkbox
     */


    /*
     * Handle own strategy text change
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('../../Modules.scss');
      // const medal = require('../Assets/medal1.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Strategies are methods you will use to help your child achieve and/or maintain healthy habits.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'These strategies may help you achieve your goals you set in Getting Ready.'
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Would you like to set your own strategies?'
          ),
          _react2.default.createElement(_components.SetStrategies, { type: 'strategy', handleAdd: this.handleAddStrategy, handleRemove: this.handleRemoveStrategy,
            handleChange: this.handleOwnStrategy, inputfields: this.state.strategies }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'p',
            null,
            'Here are some examples of some strategies:'
          ),
          _react2.default.createElement(
            ReactBootstrap.Table,
            { striped: true, bordered: true },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Strategies'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Steps'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'What is needed to do this'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Add this to my strategies'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              this.state.hardcodedStrats.map(function (item, index) {
                return _react2.default.createElement(
                  'tr',
                  { key: 'hardcoded' + index },
                  _react2.default.createElement(
                    'td',
                    null,
                    item.strategy
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.steps
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.whatIsNeeded
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      ReactBootstrap.Checkbox,
                      { onChange: function onChange() {
                          _this2.handleChange(index);
                        }, checked: item.add },
                      item.add
                    )
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Modal,
            { show: this.state.showModal, onHide: this.close },
            _react2.default.createElement(
              ReactBootstrap.Modal.Header,
              { closeButton: true },
              _react2.default.createElement(
                ReactBootstrap.Modal.Title,
                { className: styles.darkOrangeText },
                'Your strategies have been added!'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Modal.Body,
              null,
              _react2.default.createElement(
                'p',
                null,
                'Your strategies have been added to your profile!'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/profile' },
                  'Click here'
                ),
                ' to go to your profile, and fill in the steps and what is required to achieve that strategy.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Otherwise, press ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'Return to Main Menu'
                ),
                ' to return to the module selection page.'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Modal.Footer,
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/moduleslanding' },
                _react2.default.createElement(
                  ReactBootstrap.Button,
                  { className: 'btn-success' },
                  'Return to Main Menu'
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module1App10;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  updateStrategies: _propTypes2.default.func,
  strategies: _propTypes2.default.array
}, _temp2)) || _class);
exports.default = Module1App10;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/App/App10.js
// module id = 1164
// module chunks = 0